import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconInfoSimple: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconInfoSimple"><Circle cx="12" cy="5" r="1" fill="currentColor"/><Path d="M9 9.5H12V19.5M12 19.5H9M12 19.5H15" stroke="currentColor"/></CentralIconBase>;
});

export default IconInfoSimple;
